import React, { useState, } from 'react';
import axios from 'axios';
import { Modal, Input, message, Form, } from 'antd';
import './index.less';

const { TextArea } = Input;

const LeaseModal = (props) => {

  const { canceLease, isShowLease} = props

  const [form] = Form.useForm();

  const [css1, setCss1] = useState({});
  const [css2, setCss2] = useState({});
  const [css3, setCss3] = useState({});
  const [css4, setCss4] = useState({});
  const [css5, setCss5] = useState({});
  const [css6, setCss6] = useState({});
  const [font1, setFont1] = useState("");
  const [font2, setFont2] = useState("");
  const [font3, setFont3] = useState("");
  const [font4, setFont4] = useState("");
  const [font5, setFont5] = useState("");
  const [font6, setFont6] = useState("");

  const changeCss1 = () => {
    if (css1.background === undefined) {
      setCss1({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "2px solid #ED0000",
      })
      setFont1("笔记本,")
    } else {
      setCss1({})
      setFont1("")
    }
  }

  const changeCss2 = () => {
    if (css2.background === undefined) {
      setCss2({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "2px solid #ED0000",
      })
      setFont2("台式电脑,")
    } else {
      setCss2({})
      setFont2("")
    }
  }

  const changeCss3 = () => {
    if (css3.background === undefined) {
      setCss3({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "2px solid #ED0000",
      })
      setFont3("打印机,")
    } else {
      setCss3({})
      setFont3("")
    }
  }

  const changeCss4 = () => {
    if (css4.background === undefined) {
      setCss4({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "2px solid #ED0000",
      })
      setFont4("手机,")
    } else {
      setCss4({})
      setFont4("")
    }
  }

  const changeCss5 = () => {
    if (css5.background === undefined) {
      setCss5({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "2px solid #ED0000",
      })
      setFont5("投影仪,")
    } else {
      setCss5({})
      setFont5("")
    }
  }

  const changeCss6 = () => {
    if (css6.background === undefined) {
      setCss6({
        background: "#FEF7F6",
        borderRadius: "10px",
        border: "2px solid #ED0000",
      })
      setFont6("其他,")
    } else {
      setCss6({})
      setFont6("")
    }
  }

  const submitForm = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/user/userEnterpriseLeaseApply/insertRecord',
    responseType: 'json',
    data
  })

  const onFinish = (values) => {
    const categoryNames = font1 + font2 + font3 + font4 + font5 + font6;
    submitForm({
      categoryNames: categoryNames || undefined,
      customerRequirement: values?.customerRequirement ? values.customerRequirement : '',
      telephone: values?.telephone ? values.telephone : undefined,
      consultType: 2,
      consultSource: 1,
    }).then(res => {
      if (res?.data?.code === 1) {
        canceLease()
        message.success(res.data.msg);
      } else {
        values?.telephone ? message.error(res.data.msg) : message.error('请填写联系电话');
      }
    });
  };


  return (
    <Modal
      visible={isShowLease}
      onCancel={canceLease}
      footer={null}
      className="modalLease"
      getContainer={false}
      width={660}
      zIndex={99999999}
    >
      <div className="modalContainer">
        <Form name="basic" onFinish={onFinish} form={form}>
          <div className="title">企业租赁</div>
          <div className="title-top">您意向租赁的产品（可多选）</div>
          <div className="icons">
            <div className="iconTop">
              <div className="left" style={css1} onClick={changeCss1}>
                <div className="left-pic"></div>
                <div className="left-font">笔记本</div>
              </div>
              <div className="center" style={css2} onClick={changeCss2}>
                <div className="center-pic"></div>
                <div className="center-font">台式电脑</div>
              </div>
              <div className="right" style={css3} onClick={changeCss3}>
                <div className="right-pic"></div>
                <div className="right-font">打印机</div>
              </div>
            </div>
            <div className="iconBottom">
              <div className="left" style={css4} onClick={changeCss4}>
                <div className="left-pic"></div>
                <div className="left-font">手机</div>
              </div>
              <div className="center" style={css5} onClick={changeCss5}>
                <div className="center-pic"></div>
                <div className="center-font">投影仪</div>
              </div>
              <div className="right" style={css6} onClick={changeCss6}>
                <div className="right-pic"></div>
                <div className="right-font">其他</div>
              </div>
            </div>
          </div>
          <div className="title-center">其它要求（选填，可不填）</div>
          <div className="textArea">
            <Form.Item name="customerRequirement">
              <TextArea
                className="TextArea"
                showCount={true}
                bordered={false}
                maxLength={200}
                placeholder="其他要求，例如新旧程度等；推荐方案免费咨询，不收取任何费用，快速配置最合适的配置方案。"
              />
            </Form.Item>
          </div>
          <div className="form">
            <div className="title-bottom">联系电话：</div>
            <Form.Item name="telephone">
              <div className="input">
                <Input type="text" className="input-child" placeholder="请输入手机号" />
              </div>
            </Form.Item>
          </div>
          <button className="button" htmlType="submit">提交委托</button>
        </Form>
      </div>
    </Modal>
  )
}

export default LeaseModal;